import React from "react";
//Icons
import EditIcon from 'react-icons/lib/md/edit';
import ToolTipItem from "../utils/tooltip";
import ActionTypeBadge from "./action-type-badge";
import ServerPaginatedTable from "../utils/pagination.server";
import {Link} from 'react-router-dom';
import ViewIcon from 'react-icons/lib/md/remove-red-eye';

const WorkflowTableStructure = ({data, editCallback, pageIndex }) => (
    <table className="table table-striped table-hover">
        <thead>
            <tr>
                <th>
                    <span>S/N</span>
                </th>
                <th>
                    <span>Name</span>
                </th>
                <th>
                    <span>Process</span>
                </th>
                <th>
                    <span>Steps</span>
                </th>
                <th>
                    Action
                </th>
            </tr>
        </thead>
        <tbody>
        {data.map((item, i) => <tr key={i}>
            <td className="text-capitalize">{ `${pageIndex + i + 1}`  }</td>
            <td className="text-capitalize">{item.Name}</td>
            <td className="text-capitalize">{item.WorkflowProcessName}</td>
            <td className="text-capitalize" value={item.ActionTypes}>
                <span>
                    {
                        item.WorkflowActions.map((actionItem, k) => <span key={k} ><ActionTypeBadge data={actionItem}/>&nbsp;</span>)
                    }
                </span>
            </td>
            <td>
                <Link to={`/workflow-user/${item.Id}`} className="text-primary pointer">
                    <ToolTipItem key={i + 'viewWorkflow'} title={<ViewIcon size="15" color="#43a8df"/>} content='View Workflow' id={i + 'viewWorkflow'}/>
                </Link>&nbsp;
                <span className="text-primary pointer" onClick={(e) => editCallback(item)}>
                   <ToolTipItem key={i + 'edit'} title={<EditIcon size="15" color="#ff1744"/>} content='Edit record' id={i + 'edit'}/>
                 </span>
            </td>
        </tr>)}
        </tbody>
    </table>
);

class WorkflowTable extends React.Component {
    render() {
        let { data, editCallback, currentPage, pageDataCallback, pageSize, totalRecordsCount } = this.props;
        let pageIndex = (currentPage - 1) * pageSize;
        return (
            <ServerPaginatedTable currentPage={currentPage} fetchMore={pageDataCallback} target={<WorkflowTableStructure pageIndex={pageIndex} editCallback={editCallback} data={data}/>} pageSize={pageSize} totalCount={ totalRecordsCount }/>
        )
    }
}
export default WorkflowTable;



// WEBPACK FOOTER //
// ./src/views/workflow/workflow-table.js